import { tz, TZDate } from "@date-fns/tz";
import { format } from "date-fns";
import { ko } from "date-fns/locale";

const IANA_TIMEZONE = {
  KO: "Asia/Seoul",
};

export const formatInKST: typeof format = (date, formatStr, options) => {
  return format(date, formatStr, {
    locale: ko,
    in: tz(IANA_TIMEZONE.KO),
    ...options,
  });
};

export const toKSTDate = (date: string | number | Date) => {
  return new TZDate(new Date(date), IANA_TIMEZONE.KO);
};
